<div class="toast" [ngClass]="data.status ? 'success' : 'failure' ">
  <div class="toast-header" [ngClass]="data.status ? 'success' : 'failure' ">
    <strong class="mr-auto" [innerHTML]="data.message">{{data.status ? 'Success!' : 'Failure'}}</strong>
    <button type="button" class="ml-2 mb-1 close" (click)="close()">
      <span>&times;</span>
    </button>
  </div>
</div>
